import { HeatMap } from '@/components/visualisations/HeatMap';
import { eventMarkersAtom, unwrappedEventMarkersAtom } from '@/atoms/queries/eventData';

export const DataLockerHeatMap = () => (
  <HeatMap pitchEventsAtom={eventMarkersAtom} unwrappedPitchEventsAtom={unwrappedEventMarkersAtom} />
);
